/**
 * @flow
 * @author: Chinmaya
 */
import React from 'react'
import styled from 'react-emotion'
import GatsLink from 'gatsby-link'

import ResponsiveContainer from '../core/ResponsiveContainer'
import BaseImg from '../Img'
import DownArrow from '../Icons/HeaderDownArrow'
import Button from '../Button'
import BaseCloseIcon from '../Icons/CloseIcon'

export const ImageLink = styled('a')`
  margin-top: ${props => (props.isScrolled ? '0px' : '1.25em')}; /* 20/16 */
`
export const CloseIconContainer = styled(Button)`
  background: transparent;
  padding: 1.25em;
  border: none;
  background-color: transparent;
  align-self: flex-end;
  margin-right: 1em;
`

export const CloseIcon = styled(BaseCloseIcon)``

export const Img = styled(BaseImg)``

export const MenuDropdown = styled('span')`
  color: ${props =>
    props.isScrolled
      ? props.theme.navbar.transparentNavTextColor
      : props.theme.navbar.navTextColor};
  font-family: Roboto;
  font-weight: 400;
  margin: 0px 2em;
  cursor: pointer;
  display: flex;
  align-items: center;
`

export const MobileNavContainer = styled('nav')`
  position: fixed;
  top: 0;
  width: 100vw;
  padding: 0.7em 0px;
  z-index: 100;
  background: ${props =>
    props.isScrolled ? props.scrolledBackground : props.defaultBackground};
  border: ${props =>
    props.isScrolled
      ? 'solid 1px #dadee1'
      : props.showBorder ? 'solid 1px #dadee1' : 'none'};
  box-shadow: ${props =>
    props.isScrolled
      ? '0 1px 2px 0 rgba(0, 0, 0, 0.2)'
      : props.showBorder ? '0 1px 2px 0 rgba(0, 0, 0, 0.2)' : 'none'};
`

export const MobileMenuButton = styled(Button)`
  background: transparent;
  border: none;
  outline: none;
  margin-top: ${props => (props.isScrolled ? '0px' : '1.25em')}; /* 20/16 */
`

export const EachItemContainer = styled('div')`
  display: flex;
`

export const SidebarContainer = styled('div')`
  font-size: 16px;
  position: fixed;
  z-index: 200;
  top: 0;
  bottom: 0;
  right: 0;
  background: white;
  width: ${props => (props.isOpen ? '19.2em' : '0px')};
  display: ${props => (props.isOpen ? 'auto' : 'none')};
  height: 100vh;
  ${'' /* padding-bottom: 20vh; */} overflow: auto;
  transition: width 0.3s;
  transition-timing-function: ease-in;
  box-shadow: 0 5.5px 5px 0 rgba(0, 0, 0, 0.24);
`

export const CollapsibleTriggerContainer = styled('div')``

export const PageContainer = styled(ResponsiveContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: visible;
`

export const MobileNavContent = styled(PageContainer)`
  justify-content: space-between;
  align-items: ${props => (props.isScrolled ? 'center' : 'flex-start')};
`
export const MobileElementsContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Section = styled('div')`
  display: flex;
  flex-direction: row;
`

export const HeaderElement = styled('header')`
  font-size: 16px;
  background: ${props =>
    props.isScrolled ? props.scrolledBackground : props.defaultBackground};
  display: flex;
  position: fixed;
  top: 0;
  width: 100%;
  justify-content: space-between;
  padding: ${props => (props.isMobile ? '0.675em 0px' : '0.75em 0px')};
  border: ${props =>
    props.isScrolled
      ? 'solid 1px #dadee1'
      : props.showBorder ? 'solid 1px #dadee1' : 'none'};
  box-shadow: ${props =>
    props.isScrolled
      ? '0 1px 2px 0 rgba(0, 0, 0, 0.2)'
      : props.showBorder ? '0 1px 2px 0 rgba(0, 0, 0, 0.2)' : 'none'};
  z-index: 100;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  background-clip: padding-box;
`

export const Link = styled('div')`
  color: ${props =>
    props.isScrolled
      ? props.theme.navbar.transparentNavTextColor
      : props.theme.navbar.navTextColor};
  cursor: pointer;
  font-family: Roboto;
  font-weight: 400;
  text-transform: none;
  margin-left: 2em;
  outline: none !important;
`

export const MobileLink = styled(Link)`
  color: #3d4555;
  height: 57px;
  width: 95.5%;
  margin-left: auto;
  display: flex;
  align-items: center;
  padding-left: 30px;
  &:hover {
    background-color: #eee;
  }
`

const Icon = styled('img')`
  width: 1.5em;
  height: 1.5em;
  object-fit: contain;
`

export const DropDownArrow = styled(DownArrow)`
  object-fit: contain;
  margin-left: 0.625em;
  transition: all 0.4s linear;
  transform: ${props => (props.isOpen ? 'rotate(180deg)' : '')};
`

const IconWithLink = styled('a')`
  padding-left: 22px;
  font-family: Roboto;
  font-weight: 400;
  text-transform: none;
`
const FooterIconWithLink = styled(IconWithLink)`
  padding-left: 0px;
`

const HrefLink = styled(GatsLink)`
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  &:focus {
    text-decoration: none;
  }
  &:active {
    text-decoration: none;
  }
  &:visited {
    text-decoration: none;
  }
`

export const WhiteFBIcon = () => (
  <IconWithLink href="http://www.facebook.com/">
    <Icon src="/assets/images/NavBar/Icons/ic-facebook-logo-white.svg" />
  </IconWithLink>
)
export const FooterWhiteFBIcon = () => (
  <FooterIconWithLink href="http://www.facebook.com/">
    <Icon src="/assets/images/NavBar/Icons/ic-facebook-logo-white.svg" />
  </FooterIconWithLink>
)

export const ColoredFBIcon = () => (
  <IconWithLink href="http://www.facebook.com/">
    <Icon src="/assets/images/NavBar/Icons/ic-facebook-logo-dark.svg" />
  </IconWithLink>
)

export const WhiteTwitterIcon = () => (
  <IconWithLink href="http://www.twitter.com/">
    <Icon src="/assets/images/NavBar/Icons/ic-twitter-logo-white.svg" />
  </IconWithLink>
)

export const FooterWhiteTwitterIcon = () => (
  <FooterIconWithLink href="http://www.twitter.com/">
    <Icon src="/assets/images/NavBar/Icons/ic-twitter-logo-white.svg" />
  </FooterIconWithLink>
)
export const ColoredTwitterIcon = () => (
  <IconWithLink href="http://www.twitter.com/">
    <Icon src="/assets/images/NavBar/Icons/ic-twitter-logo-dark.svg" />
  </IconWithLink>
)

export const MobileMenuIcon = () => (
  <Icon src="/assets/images/NavBar/Icons/ic_menu_white_24px.svg" />
)

export const ColoredMobileMenuIcon = () => (
  <Icon src="/assets/images/NavBar/Icons/ic_menu_black_24px.svg" />
)

export const TeamLink = styled(Link)`
  margin-left: ${props => (props.showMargin ? '2em' : '0px')};
`

export const TeamMenuItem = props => (
  <HrefLink to="/team">
    <TeamLink {...props}>Team</TeamLink>
  </HrefLink>
)
export const CareerMenuItem = props => (
  <HrefLink to="/careers">
    <Link {...props}>Careers</Link>
  </HrefLink>
)
export const InvestorMenuItem = props => (
  <HrefLink to="/investor-relations">
    <Link {...props}>Investor Relations</Link>
  </HrefLink>
)
export const OfficesMenuItem = props => {
  if (props.linkTo) {
    return (
      <HrefLink to={props.linkTo}>
        <Link {...props}>Offices</Link>
      </HrefLink>
    )
  }
  return <Link {...props}>Offices</Link>
}

export const ContactUsMenuItem = props =>
  props.isMobile ? (
    <MobileLink onClick={props.scrollTo} {...props}>
      Contact Us
    </MobileLink>
  ) : (
    <Link onClick={props.scrollTo} {...props}>
      Contact Us
    </Link>
  )

export const IBCricketMenuItem = props => {
  if (props.linkTo) {
    return (
      <HrefLink to={props.linkTo}>
        <Link {...props}>iB Cricket</Link>
      </HrefLink>
    )
  }
  return <Link {...props}>iB Cricket</Link>
}

export const HomeMenuItem = props =>
  props.isMobile ? (
    <MobileLink onClick={props.scrollTo} {...props}>
      Home
    </MobileLink>
  ) : (
    <Link onClick={props.scrollTo} {...props}>
      Home
    </Link>
  )

export const MobileCollapseMenuLink = styled('a')`
  border-top: solid 1px rgba(74, 81, 97, 0.1);
  cursor: pointer;
  padding: 1.35em 2.15em;
  width: 100%;
  color: rgb(67, 72, 76);

    &:hover{
      text-decoration: none;
      outline: none;
      color: rgb(67, 72, 76);
    }
    &:active{
      text-decoration: none;
      outline: none;
      color: rgb(67, 72, 76);
    }
    focus {
      text-decoration: none;
      outline: none;
      color: rgb(67, 72, 76);

    }
  }
`

export const CollapsibleTrigger = styled(MobileCollapseMenuLink)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${props => (props.isOpen ? '#edf3fa' : 'transparent')};
`

export const CollapsibleContent = styled('div')`
  overflow: auto !important;
  background: ${props => (props.isOpen ? '#edf3fa' : 'transparent')};
`

export const MobileSideOptionsList = styled('ul')`
  list-style: none;
  padding: 0px;
  display: flex;
  flex-direction: column;
  background: 'transparent';
`

export const MobileCollapseTeamLink = styled('a')`
  color: rgb(67, 72, 76);
  padding: 1.35em 2.15em;
  border-top: solid 1px rgba(74, 81, 97, 0.1);
  width: 100%;
  &:hover {
    text-decoration: none;
  }
`

export const TwitterIcon = props =>
  props.isScrolled ? (
    <ColoredTwitterIcon />
  ) : props.isFooter ? (
    <FooterWhiteTwitterIcon />
  ) : (
    <WhiteTwitterIcon />
  )

export const FBIcon = props =>
  props.isScrolled ? (
    <ColoredFBIcon />
  ) : props.isFooter ? (
    <FooterWhiteFBIcon />
  ) : (
    <WhiteFBIcon />
  )

export const MenuIcon = props =>
  props.isScrolled ? <ColoredMobileMenuIcon /> : <MobileMenuIcon />
